export const appCdnURL = ""

export const appBuildAssetsDir = "/_nuxt/2026110509"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0;"},{"name":"keywords","content":"online Shopping; discount shopping; fast delivery; mobile phones; laptop; women’s fashion; men’s fashion; Samsung; OPPO; Vivo; Huawei; Apple; shoes; home appliance; home& living; Black Friday; Christmas Sale; Kilimall Anniversary"},{"name":"robots","content":"all"},{"name":"google-site-verification","content":"OkbLQWAI5EwE1ZYBnoqkWAOIASsjGbOvnK09aFksCsY"},{"name":"facebook-domain-verification","content":"kaecobftnbyknc6ln51jgopse42kfi"}],"link":[{"rel":"manifest","href":"/js/manifest.webmanifest","crossorigin":"use-credentials"},{"rel":"icon","type":"image/x-icon","href":"https://image.kilimall.com/kenya/new_wap/logo/icon_48.ico"}],"style":[],"script":[{"src":"/js/flexibleNew.js"},"\n  (function () {\n    var ADS_ID_MAP = {\n      KE: 'AW-965268020',\n      UG: 'AW-11394122990'\n    };\n    var cookieMatch = document.cookie.match(/(?:^|;\\s*)regionCode=([^;]+)/);\n    var cookieCountryCode = cookieMatch ? decodeURIComponent(cookieMatch[1]) : '';\n    var hostCountryCode = /(^|\\.)ug(\\.|$)/i.test(window.location.hostname) ? 'UG' : 'KE';\n    var countryCode = (cookieCountryCode || hostCountryCode || 'KE').toUpperCase();\n    var tagId = ADS_ID_MAP[countryCode] || ADS_ID_MAP.KE;\n\n    // Google tag (gtag.js) - 官方建议：尽早初始化 dataLayer 并加载 gtag.js\n    window.dataLayer = window.dataLayer || [];\n    window.gtag = window.gtag || function gtag(){ window.dataLayer.push(arguments); };\n\n    var script = document.createElement('script');\n    script.async = true;\n    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + tagId;\n    var firstScript = document.getElementsByTagName('script')[0];\n    if (firstScript && firstScript.parentNode) {\n      firstScript.parentNode.insertBefore(script, firstScript);\n    } else {\n      document.head.appendChild(script);\n    }\n\n    gtag('js', new Date());\n    gtag('config', tagId);\n  })();\n",{"src":"https://www.googletagmanager.com/gtag/js?id=G-MBL06JR793","async":true},"\n          window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n\n          gtag('config', 'G-MBL06JR793');\n        ",{"src":"/js/regions-pwa.min.js","async":true},"\n          !function (w, d, t) {\n            w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=[\"page\",\"track\",\"identify\",\"instances\",\"debug\",\"on\",\"off\",\"once\",\"ready\",\"alias\",\"group\",\"enableCookie\",\"disableCookie\",\"holdConsent\",\"revokeConsent\",\"grantConsent\"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(\n          var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r=\"https://analytics.tiktok.com/i18n/pixel/events.js\",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement(\"script\")\n          ;n.type=\"text/javascript\",n.async=!0,n.src=r+\"?sdkid=\"+e+\"&lib=\"+t;e=document.getElementsByTagName(\"script\")[0];e.parentNode.insertBefore(n,e)};\n\n\n            ttq.load('D0VVQ3BC77U53580QC7G');\n            ttq.page();\n          }(window, document, 'ttq');\n        "],"noscript":[],"title":"Kilimall - Affordable Online Shopping"}

export const appBaseURL = "/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000